import React from 'react';
import { Page, Text, BlockStack } from "@shopify/polaris";

import Link from "../../components/Link";
import styles from "./Forbidden.module.css";

function Forbidden() {
  return (
    <Page>
      <div className={styles.container}>
        <div className={styles.item}>
          <BlockStack gap="200">
            <Text variant="heading2xl" as="p">
              403
            </Text>
            <Text variant="heading3xl" as="p">
              Forbidden
            </Text>
            <p>Looks like you're not authorized to access this page.</p>
            <br />
            <Link url="/">Home</Link>
          </BlockStack>
        </div>
      </div>
    </Page>
  );
};


export default Forbidden;
